module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_8004.d2fedfc1.png";